import { render, staticRenderFns } from "./WhitelistsTable.vue?vue&type=template&id=409163d4&scoped=true&"
import script from "./WhitelistsTable.vue?vue&type=script&lang=js&"
export * from "./WhitelistsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409163d4",
  null
  
)

export default component.exports